export class Listenable {
    _listeners = new Map();
    
    on(name, callback) {
        if (!this._listeners.has(name)) {
            this._listeners.set(name, new Set());
        }

        this._listeners.get(name).add(callback);
    }

    off(name, callback) {
        this._listeners.get(name)?.delete(callback);
    }

    emit(name, data) {
        this._listeners.get(name)?.forEach(fn => fn(data));
    }
}